export const isTestUrl = () => {
  // Check if 'test' is in the window.location.hash
  return window ? window.location.hash.indexOf('test') > -1 : false;
};

export const isTestArtificialNetworkDelays = () => {
  return window ? window.location.hash.indexOf('delays') > -1 : false;
};
